import HairStylingStudio from '../../hair-styling/pages/HairStylingStudio';

/** Dedicated hair-color FLUX studio — same kiosk layout as hairstyle (compare, upload, QR). */
export default function HairColoringStudio() {
  return <HairStylingStudio forcedFocus="color" />;
}
